/* eslint-disable no-unused-vars */
import axios from 'axios'
import qs from 'qs'
import _cookies from 'js-cookie'
import nprogress from 'nprogress'
import config, { ENV } from '@/config/config.js'


var passport_address = config.passport_address
var general_address = config.general_address
var doc_address = config.doc_address



var _request = {
    api(param) {
        nprogress.start()
        axios({
            method: param.method || 'get',
            url: param.url || '',
            responseType: param.type || 'json',
            params: param.params || '',
            data: param.data || '',
            paramsSerializer: function (params) {
                return qs.stringify(params, { arrayFormat: 'repeat' })
            },
            headers: {
                "staff_center_login_key": _cookies.get('staff_center_login_key') || ''
            }
        },
            {
                timeout: 1000 * 60 * 5
            }).then(function (response) {
                nprogress.done()
                if (response.data == null) {
                    typeof param.success === 'function' && param.success(response)
                    return

                }
                if (-600000 === response.data.code) {
                    // 去登陆
                    if (ENV != 'dev' && ENV != 'development') {
                        window.location.href = passport_address + '/login'
                    }

                } else if (-600002 === response.data.code) {
                    window.location.replace(general_address + '/not-power')
                } else if (0 === response.data.code) {
                    // 返回结果
                    if (null != response.data.total) {
                        // 分页数据
                        typeof param.success === 'function' && param.success(response.data.data, response.data.total, response.data.msg)
                    } else {
                        // 常规数据
                        typeof param.success === 'function' && param.success(response.data.data, response.data.message)
                    }
                }
                else {
                    // 请求失败
                    if (response.data.data != undefined) {
                        typeof param.error === 'function' && param.error(response.data.message, response.data.data)
                 
                    } else {
                        typeof param.error === 'function' && param.error(response.data.message, response.data.data, response.data.code)
                
                    }

                }
            })
    },
    download(url, name = '') {

        // 获取当前时间
        var current_time = new Date();

        // 格式化为字符串格式
        var formatted_date = current_time.getFullYear() + "-" +
                            (current_time.getMonth() + 1).toString().padStart(2, "0") + "-" +
                            current_time.getDate().toString().padStart(2, "0") + " " 

        // 获取XMLHttpRequest
        let xmlResquest = new XMLHttpRequest();
        //  发起请求
        xmlResquest.open("get", url, true);
        // 设置请求头类型
        xmlResquest.setRequestHeader("Content-type", "application/json");
        //  设置请求token
        xmlResquest.setRequestHeader(
            "staff_center_login_key", _cookies.get('staff_center_login_key') || ''
        );
        xmlResquest.responseType = "blob";
        //  返回
        xmlResquest.onload = function (oEvent) {
            let content = xmlResquest.response;
            // 组装a标签
            let elink = document.createElement("a");
            // 设置下载文件名
            elink.download = "发票信息批量导出"+ formatted_date + ".xlsx";
            elink.style.display = "none";
            let blob = new Blob([content]);
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
        };
        xmlResquest.send();
    },
    // 上传文件
    upload(param) {
        var formData = new FormData()
        formData.append('file', param.file)
        var configs = {
            headers: {
                'Content-Type': 'multipart/form-data',
                "staff_center_login_key": _cookies.get('staff_center_login_key') || ''
            }
        }
        nprogress.start()
        // 添加请求头
        axios.post(param.url, formData, configs)
            .then(response => {
                nprogress.done()
                if (-600000 === response.data.code) {
                    // 去登陆
                    window.location.href = passport_address
                }
                else if (0 === response.data.code) {
                    // 常规数据
                    typeof param.success === 'function' && param.success(response.data.data, response.data.message)
                }
                else {
                    // 请求失败
                    typeof param.error === 'function' && param.error(response.data.message)
                }
            })
    },
    // 获取服务器地址
    getStaffsUrl(path) {
        return config.staffs_center_address + path;
    },
    getCrmUrl(path) {
        return config.crm_address + path;
    },
    getCrmBaseUrl(path) {
        return config.crm_base_address + path;
    },
    getFinanceUrl(path) {
        return config.finance_url + path;
    },
    getCardsUrl(path) {
        return config.cards_address + path;
    },
    getApprovalUrl(path) {
        return config.approval_address + path;
    },
    getRegionUrl(path) {
        return config.region_address + path
    },
    getSaasUrl(path) {
        return config.saas_address + path
    },

    doc_address,
    passport_address,
    general_address
}

export default _request